module.exports = __webpack_public_path__ + "static/media/how-it-works-dna-report-2x.c8e82c7a.png";